import process from 'process'

const globalScope: any =
	typeof globalThis !== 'undefined'
		? globalThis
		: typeof window !== 'undefined'
			? window
			: {}

if (!globalScope.process) {
	globalScope.process = process
}

if (!globalScope.process.env) {
	globalScope.process.env = {}
}
